<template>
  <div class="modal fade" id="boRegistrationCancel" tabindex="-1" aria-labelledby="boRegistrationCancelLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          「取引に係るご注意・契約締結前交付書面・約款等の確認」に承諾いただき、「みんなのオプション取引に関する確認事項」「取引に関する重要事項の確認について」「店頭デリバティブ取引に関する確認書」「登録情報の確認について」の各項目についてを全て「はい」に選択いただきますと、取引画面へ進めます。
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="hide()">{{$t("btn.close")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";

export default {
    name: "BoRegistrationCancelModal",
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_BO_REGISTRATION_CANCEL_MODAL, () => {
            this.show();
        });
    },
    methods: {
        show() {
            $("#boRegistrationCancel").modal("show");
        },
        hide() {
            $("#boRegistrationCancel").modal("hide");
        }
    },
}

</script>

<style scoped>
  .modal-dialog{
    max-width: 600px !important;
  }
</style>
